// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { funkiMainnet as _funkiMainnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the funkiMainnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 33979
 * Chain Name: Funki
 * Default Block Explorer: https://funkiscan.io
 * Default RPC URL: https://rpc-mainnet.funkichain.com
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { funkiMainnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: funkiMainnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const funkiMainnet = createCommon({
	..._funkiMainnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
